import { selectProfile } from '../../../../../store/workspace/selectors';
import Modal from '../../../../../components/Modal';
import { useDispatch, useSelector } from '../../../../../store/store';
import styles from './style.module.scss';
import { ChevronRightIcon, InviteMemberIcon } from '../../../../../assets/icons';
import { setAddExtraJobPostModal, setExtraServiceDetail, setExtraServicesPaymentModal } from '../../../../../store/workspace/slice';
import DropDown from '../../../../../components/DropDown';
import Button from '../../../../../components/Button';
import { useState } from 'react';

const landingUrl = process.env.REACT_APP_LANDING_URL;

interface ListItem {
    id: number;
    sub: number;
    title: string;
};

const list = [
    {
        id: 1,
        sub: 1,
        title: '1 Job post'
    },
    {
        id: 2,
        sub: 2,
        title: '2 Job post'
    },
    {
        id: 3,
        sub: 3,
        title: '3 Job post'
    },
    {
        id: 4,
        sub: 4,
        title: '4 Job post'
    },
    {
        id: 5,
        sub: 5,
        title: '5 Job post'
    },
    {
        id: 6,
        sub: 6,
        title: '6 Job post'
    },
    {
        id: 7,
        sub: 7,
        title: '7 Job post'
    },
    {
        id: 8,
        sub: 8,
        title: '8 Job post'
    },
    {
        id: 9,
        sub: 9,
        title: '9 Job post'
    },
    {
        id: 10,
        sub: 10,
        title: '10 Job post'
    },
    {
        id: 11,
        sub: 0,
        title: '+10 Job post'
    },
];

const basePriceList = {
    free_trial: 0,
    standard_monthly: 60,
    standard_annual: 50,
    professional_monthly: 44,
    professional_annual: 38,
};

const baseApplicantsList = {
    free_trial: 0,
    standard_monthly: 50,
    standard_annual: 50,
    professional_monthly: 60,
    professional_annual: 60,
};

export default function AddExtraJobPost() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [selectedItem, setSelectedItem] = useState<ListItem | null>(null);
    const pricePerItem = basePriceList[profile?.planType || 'standard_monthly'];
    const applicantsPerItem = baseApplicantsList[profile?.planType || 'standard_monthly'];

    const renderDropdownList = list.map(item => {
        const applicants = item.id === 11 ? '' : `+ ${item.sub * applicantsPerItem} Applicants`
        return { ...item, title: `${item.title} ${applicants}` }
    })

    const openContactSales = () => {
        window.open(`${landingUrl}/book-demo`, '_blank');
    };

    const submit = () => {
        if (!selectedItem) return;

        dispatch(setExtraServiceDetail({
            type: 'job',
            sub: selectedItem.sub,
        }));

        dispatch(setAddExtraJobPostModal(false));
        dispatch(setExtraServicesPaymentModal(true));
    };

    return (
        <Modal
            size='md'
            title='Add job post'
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setAddExtraJobPostModal(false))}
        >
            <h6>To add more, an additional job post charge applies.</h6>

            <DropDown
                idKey='id'
                titleKey='title'
                setItem={setSelectedItem}
                selectedItem={selectedItem}
                dropDownList={renderDropdownList}
                containerClassName={styles.dropdown}
            />

            {selectedItem?.id !== 11 && <div className={styles.calc}>
                <h6>${pricePerItem} Per 1 Job Post + {(selectedItem?.sub || 0) * applicantsPerItem} Applicants</h6>
                <h4>${(selectedItem?.sub || 0) * pricePerItem}.00</h4>
            </div>}

            {selectedItem?.id === 11 && <div className={styles.info}>
                <h6>For more than 1000 applicants you should contact sales!</h6>
                <div className={styles.info_link} onClick={openContactSales}>
                    <span>Contact sales</span>
                    <ChevronRightIcon />
                </div>
            </div>}

            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setAddExtraJobPostModal(false))}
                />
                <Button
                    text='pay'
                    type='Primary'
                    onClick={submit}
                    className={styles.actions_btn}
                    disabled={!selectedItem || (selectedItem.id === 11)}
                />
            </div>
        </Modal>
    )
}
